module.exports = __webpack_public_path__ + "img/image16.539cb8db.png";